import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import {FiArrowRight} from '../assets/icons/vander'
import { eventData } from '../data/data'

export default function EventTab() {
    let [activeTab, setActiveTab] = useState(1)
  return (
    <div className="row">
        <div className="col-md-4 mt-4 pt-2">
            <ul className="nav nav-pills nav-justified flex-column bg-white rounded shadow p-3 mb-0 sticky-bar">
                <li className="nav-item">
                    <Link className={`nav-link rounded border-0 ${activeTab === 1 ? 'active' : ''}`} to="#" onClick={() => setActiveTab(1)}>

                        <div className="text-center pt-1 pb-1">
                            <h6 className="title fw-normal mb-0">Marketing</h6>
                        </div>
                    </Link>
                </li>
                
                <li className="nav-item mt-2">
                    <Link className={`nav-link rounded border-0 ${activeTab === 2 ? 'active' : ''}`} to="#" onClick={()=>setActiveTab(2)}>
                        <div className="text-center pt-1 pb-1">
                            <h6 className="title fw-normal mb-0">Speakers</h6>
                        </div>
                    </Link>
                </li>
                
                <li className="nav-item mt-2">
                    <Link className={`nav-link rounded border-0 ${activeTab === 3 ? 'active' : ''}`} to="#" onClick={()=>setActiveTab(3)}>
                        <div className="text-center pt-1 pb-1">
                            <h6 className="title fw-normal mb-0">Production</h6>
                        </div>
                    </Link>
                </li>
                
                <li className="nav-item mt-2">
                    <Link className={`nav-link rounded border-0 ${activeTab === 4 ? 'active' : ''}`} to="#" onClick={()=>setActiveTab(4)}>
                        <div className="text-center pt-1 pb-1">
                            <h6 className="title fw-normal mb-0">Attendees</h6>
                        </div>
                    </Link>
                </li>
            </ul>
        </div>

        <div className="col-md-8 col-12 mt-4 pt-2">
            <div className="tab-content">
                {eventData.map((item,index)=>{
                    return(
                        <div className={`tab-pane fade bg-white p-4 rounded shadow ${activeTab === item.id ? 'show active' : ''}`} key={index}>
                            <img src={item.image} className="img-fluid rounded shadow" alt=""/>
                            <div className="mt-4">
                                <p className="text-muted">{item.desc}</p>
                                <Link to="#" className="text-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </div>
  )
}
